<div class="col-md-12 mb-1 mt-4">
    <h6 class="my-3 text-mad text-uppercase">1st Term</h6>
</div>
<div class="col-md-12 mat-table-wrapper">
    <table class="table lmat-elevation-z8" style="overflow: hidden;">
        <tr>
            <th class="calculation__name">
                <ng-container *ngTemplateOutlet="yearsPurchase; context: {year: rentReview, rate: targetRate}"></ng-container>
            </th>
            <td class="calculation__value">
                <ng-container *ngIf="data.yearsPurchaseOfRentReviewCycle; else notAvailable">
                    {{data.yearsPurchaseOfRentReviewCycle}}
                </ng-container>
            </td>
            <td class="calculation__tooltip">
                <ng-template #popYearsPurchase>
                    <strong>Calculation:</strong> 
                        <ng-container *ngTemplateOutlet="yearsPurchase; context: {year: rentReview, rate: targetRate}"></ng-container>
                    <br>
                    = 
                        <span class="text-red">(1 - (1 + </span>
                        <span class="text-blue">(Target Rate)</span>
                        <span class="text-red">)</span>
                        <sup>
                            <span class="text-red">-</span>
                            <span class="text-blue">(Rent Review Cycle)</span>
                        </sup>
                        <span class="text-red">)/</span>
                        <span class="text-blue">(Target Rate)</span>
                    <br>
                    <ng-container *ngIf="data.yearsPurchaseOfRentReviewCycle">
                        =  
                            <span class="text-red">(1 - (1 + </span>
                            <span class="text-blue">{{targetRate}}%</span>
                            <span class="text-red">)</span>
                            <sup>
                                <span class="text-red">-</span>
                                <span class="text-blue">{{rentReview | mask:'separator.2'}}</span>
                            </sup>
                            <span class="text-red">)/</span>
                            <span class="text-blue">{{targetRate}}%</span>
                        <br>
                        = <span class="text-green">{{data.yearsPurchaseOfRentReviewCycle}}</span>
                    </ng-container>
                </ng-template>
                <span popoverClass="my-popover" placement="top" container="body" [ngbPopover]="popYearsPurchase" style="cursor: pointer;">
                    <mat-icon color="primary">information</mat-icon>
                </span>
            </td>
        </tr>

        <tr class="gray"> 
            <th>
                <ng-container *ngTemplateOutlet="presentValue; context: {year: fittingOut, rate: targetRate}"></ng-container>
            </th>
            <td>
                <ng-container *ngIf="data.presentValueOfFittingOutPeriod; else notAvailable">
                    {{data.presentValueOfFittingOutPeriod}}
                </ng-container>
            </td>
            <td>
                <ng-template #popPresentValue>
                    <strong>Calculation:</strong> 
                        <ng-container *ngTemplateOutlet="presentValue; context: {year: fittingOut, rate: targetRate}"></ng-container>
                    <br>
                    = 
                        <span class="text-red">(1 + </span>
                        <span class="text-blue">(Target Rate)</span>
                        <span class="text-red">)</span>
                        <sup>
                            <span class="text-red">-</span>
                            <span class="text-blue">(Fitting Out Period)</span>
                        </sup>
                    <br>
                    <ng-container *ngIf="data.presentValueOfFittingOutPeriod">
                        =  
                            <span class="text-red">(1 + </span>
                            <span class="text-blue">{{targetRate}}%</span>
                            <span class="text-red">)</span>
                            <sup>
                                <span class="text-red">-</span>
                                <span class="text-blue">{{fittingOut | mask:'separator.2'}}</span>
                            </sup>
                        <br>
                        = <span class="text-green">{{data.presentValueOfFittingOutPeriod}}</span>
                    </ng-container>
                </ng-template>
                <span popoverClass="my-popover" placement="top" container="body" [ngbPopover]="popPresentValue" style="cursor: pointer;">
                    <mat-icon color="primary">information</mat-icon>
                </span>
            </td>
        </tr>

        <tr>
            <th>
                Factor Value of 1st term
            </th>
            <td>
                <ng-container *ngIf="data.factorValue; else notAvailable">
                    {{data.factorValue}}
                </ng-container>
            </td>
            <td>
                <ng-template #popFactorValue>
                    <strong>Calculation:</strong> 
                        Factor value of the 1st Term
                    <br>
                    = 
                        <span class="text-blue">(Year's Purchase)</span>
                        <span class="text-red"> x </span>
                        <span class="text-blue">(Present Value)</span>
                    <br>
                    <ng-container *ngIf="data.factorValue">
                        =  
                            <span class="text-blue">{{data.yearsPurchaseOfRentReviewCycle}}</span>
                            <span class="text-red"> x </span>
                            <span class="text-blue">{{data.presentValueOfFittingOutPeriod}}</span>
                        <br>
                        = <span class="text-green">{{data.factorValue}}</span>
                    </ng-container>
                </ng-template>
                <span popoverClass="my-popover" placement="top" container="body" [ngbPopover]="popFactorValue" style="cursor: pointer;">
                    <mat-icon color="primary">information</mat-icon>
                </span>
            </td>
        </tr>
    </table>
</div>

<ng-template #yearsPurchase let-year="year" let-rate="rate">
    Year's Purchase (YP) @<ng-container *ngIf="rate; else notAvailable">{{rate}}</ng-container>% for {{year | mask:'separator.2'}} year(s)
</ng-template>


<ng-template #presentValue let-year="year" let-rate="rate">
    Present Value (PV) @<ng-container *ngIf="rate; else notAvailable">{{rate}}</ng-container>% for {{year | mask:'separator.2'}} year(s)
</ng-template>

<ng-template #notAvailable>
    <span class="text-red">N/A</span>
</ng-template>